export default __webpack_public_path__ + "static/media/location-marker_green_yellow.cabb5484.svg";